import { useCallback } from 'react';

const useSmoothScroll = () => {
  const scrollToElement = useCallback((elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
      element.scrollIntoView({ behavior });
    }
  }, []);

  return scrollToElement;
};

export default useSmoothScroll;